<template>
  <div>
    <div class="row justify-content-between">
      <div class="col-md-6">Dinheiro</div>
      <div class="col-md-4">
        <number-input ref="input" v-model="form.payment_method_1" />
      </div>
    </div>

    <div class="row justify-content-between">
      <div class="col-md-6">Cartão Crédito</div>
      <div class="col-md-4">
        <number-input v-model="form.payment_method_3" />
      </div>
    </div>
    <!-- <template v-if="form.payment_method_3 > 0 && showCreditCardBrand == true">
      <div class="row mb-3">
        <div class="col">
          <select-input
            v-model="form.payment_method_3_credit_card_brand"
            :alias="'Bandeira do Cartão'"
            :options="creditCardBrands"
          />
        </div>
        <div class="col">
          <text-input
            v-model="form.payment_method_3_credit_card_authorization_code"
            :alias="'N. Autorização'"
          />
        </div>
        <div class="col">
          <text-input
            v-model="form.payment_method_3_credit_card_operator_cnpj"
            :alias="'Cnpj Credenciadora.'"
          />
        </div>
      </div>
    </template> -->

    <div class="row justify-content-between">
      <div class="col-md-6">Cartão Débito</div>
      <div class="col-md-4">
        <number-input v-model="form.payment_method_4" />
      </div>
    </div>

    <!-- <template v-if="form.payment_method_4 > 0 && showCreditCardBrand == true">
      <div class="row mb-3">
        <div class="col">
          <select-input
            v-model="form.payment_method_4_credit_card_brand"
            :alias="'Bandeira do Cartão'"
            :options="creditCardBrands"
          />
        </div>
        <div class="col">
          <text-input
            v-model="form.payment_method_4_credit_card_authorization_code"
            :alias="'N. Autorização'"
          />
        </div>
        <div class="col">
          <text-input
            v-model="form.payment_method_4_credit_card_operator_cnpj"
            :alias="'Cnpj Credenciadora.'"
          />
        </div>
      </div>
    </template> -->

    <div class="row justify-content-between">
      <div class="col-md-6">Cheque</div>
      <div class="col-md-4">
        <number-input v-model="form.payment_method_2" />
      </div>
    </div>

    <!-- <div class="row justify-content-between">
      <div class="col-md-6">
        Crediário
        <br />
        <small class="text-info">30 Dias</small>
      </div>
      <div class="col-md-4">
        <number-input v-model="form.payment_method_5" />
      </div>
    </div> -->
    
    <!--  v-if="form.payment_method_5 > 0" -->
    <!-- <template>
      <div class="row justify-content-end">
        <div class="col-2">
           <number-input
            v-model="number_parcels"
            :decimal-places="0"
            :alias="'Nº. Parcelas'"
          />
        </div>
        <div class="col-3">
          <text-input
            type="date"
            v-model="first_due_date"
            :alias="'Primero Vencimento'"
          />
        </div>
        {{ portion_amount }}
      </div>
    </template> -->
    <div>
      <div v-for="row in parcels">
        {{ row }}
      </div>
      <error-handler class="mt-2 mb-2" :error="error" />
    </div>
    <div class="row">
      <div class="col-md-12 text-right">
        <button class="btn btn-success" @click="handleStore()">
          Finalizar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  data: () => ({
    // first_due_date: moment()
    //   .add(30, "d")
    //   .format("YYYY-MM-DD"),
    // number_parcels: 1,
    // portion_amount: 0,

    baseParcels: [{}],
    parcels: [],
    form: {
      payment_method_1: 0,
      payment_method_2: 0,
      payment_method_3: 0,
      payment_method_3_credit_card_brand: null,
      payment_method_3_credit_card_operator_cnpj: null,
      payment_method_3_credit_card_authorization_code: null,
      payment_method_4: 0,
      payment_method_4_credit_card_brand: null,
      payment_method_4_credit_card_operator_cnpj: null,
      payment_method_4_credit_card_authorization_code: null,
      payment_method_5: 0
    },

    creditCardBrands: {
      "01": "Visa",
      "02": "Mastercard",
      "03": "American Express",
      "04": "Sorocred",
      "05": "Diners Club",
      "06": "Elo",
      "07": "Hipercard",
      "08": "Aura",
      "09": "Cabal",
      "99": "Outros"
    }
  }),

  mounted() {
    this.form.payment_method_1 = this.netTotal;
  },

  computed: {
    error() {
      return this.$store.state.orderForm.error;
    },

    netTotal() {
      return this.$store.getters["orderForm/netTotal"];
    },
    operation() {
      return this.$store.getters["orderForm/getOperation"];
    },

    showCreditCardBrand() {
      if (
        this.operation !== 1 ||
        this.$store.state.auth.user.company.module_nfe_active !== 1
      ) {
        return false;
      }
    },
    parcelsCount() {
      return this.parcels.length;
    }
  },

  methods: {
    focus() {
      this.$refs.input.focus();
    },

    getOrderBill() {
      let orderBill = [];

      if (this.form.payment_method_1 > 0) {
        orderBill.push(this.getDefaultOrderBill("1"));
      }

      if (this.form.payment_method_2 > 0) {
        orderBill.push(this.getDefaultOrderBill("2"));
      }

      if (this.form.payment_method_3 > 0) {
        orderBill.push(this.getCreditCardOrderBill("3"));
      }

      if (this.form.payment_method_4 > 0) {
        orderBill.push(this.getCreditCardOrderBill("4"));
      }

      if (this.form.payment_method_5 > 0) {
        orderBill.push(this.getBillReceivebleOrderBill("5"));
      }

      return orderBill;
    },

    getDefaultOrderBill(payment_method) {
      return {
        payment_method: payment_method,
        value: this.form["payment_method_" + payment_method],
        due_days: 0,
        due_date: moment()
          .add(0, "d")
          .format("YYYY-MM-DD")
      };
    },

    getCreditCardOrderBill(payment_method) {
      return {
        payment_method: payment_method,
        value: this.form["payment_method_" + payment_method],
        credit_card_brand: this.form[
          "payment_method_" + payment_method + "_credit_card_brand"
        ],
        credit_card_authorization_code: this.form[
          "payment_method_" + payment_method + "_credit_card_authorization_code"
        ],
        due_days: 0,
        due_date: moment()
          .add(0, "d")
          .format("YYYY-MM-DD")
      };
    },

    getBillReceivebleOrderBill(payment_method) {
      return this.parcels;
      // return {
      //   payment_method: payment_method,
      //   value: this.form["payment_method_" + payment_method],
      //   due_days: 30,
      //   due_date: moment()
      //     .add(30, "d")
      //     .format("YYYY-MM-DD")
      // };
    },

    addParcels() {
      let form = [
        {
          payment_method: 5,
          value: 0,
          due_days: 30,
          due_date: moment()
            .add(30, "d")
            .format("YYYY-MM-DD")
        }
      ];

      form.push({
        payment_method: 5,
        value: 0,
        due_days: this.getNextParcelDays(),
        due_date: moment()
          .add(this.getNextParcelDays(), "d")
          .format("YYYY-MM-DD")
      });
      this.parcels = form;
    },

    removeParcelRow(index) {
      this.$delete(this.parcels, index);
      this.divideParcels();
    },

    divideParcels() {
      this.portion_amount = this.form.payment_method_5 / this.parcelsCount;
      // console.log(this.parcelsCount);
      for (var i = 1; i < this.parcelsCount; i++) {
        this.baseParcels[i].value = this.portion_amount;
      }
    },
    // getParcels() {
    //   this.portion_amount = this.form.payment_method_5 / this.number_parcels;

    //   if (this.number_parcels > this.parcelsCount) {
    //     this.addParcels();
    //   }
    //   if (this.number_parcels < this.parcelsCount) {
    //     this.removeParcels();
    //   }

    //   this.calcParcels();
    // },

    // addParcels() {
    //   if (this.parcelsCount == 1) {
    //     this.parcels[0].payment_method = 5;
    //     this.parcels[0].value = this.portion_amount;
    //     this.parcels[0].due_days = this.getNextPaymentDays();
    //     this.parcels[0].due_date = moment(this.first_due_date)
    //       .add(this.getNextPaymentDays(), "d")
    //       .format("YYYY-MM-DD");
    //   } else {
    //   }
    //   do {
    //     this.parcels.push({
    //       payment_method: 5,
    //       value: this.portion_amount,
    //       due_days: this.getNextPaymentDays(),
    //       due_date: moment(this.first_due_date)
    //         .add(this.getNextPaymentDays(), "d")
    //         .format("YYYY-MM-DD")
    //     });
    //   } while (this.number_parcels > this.parcelsCount);
    // },
    // removeParcels() {
    //   do {
    //     this.$delete(this.parcels, this.parcelsCount - 1);
    //   } while (this.number_parcels < this.parcelsCount);
    // },

    // calcParcels() {

    //   for (var i = 1; i < this.parcelsCount; i++) {
    //     this.parcels[i].value = this.portion_amount;
    //   }
    // },

    getNextParcelDays() {
      let lastPayment = this.parcels[this.parcelsCount - 1];

      if (lastPayment.payment_method != 5) {
        return 30;
      }

      return lastPayment.due_days + 30;
    },
    handleStore() {
      this.$store.commit("orderForm/setOrderBills", this.getOrderBill());
      this.$emit("store");
    }
    // calcPayments() {
    //   this.form.payment_method_1 =
    //     this.form.payment_method_1 - this.form.payment_method_3;
    // }
  }
};
</script>

<style></style>
